import { render, staticRenderFns } from "./TasksSideBarEdit.vue?vue&type=template&id=9e52a7a0&scoped=true"
import script from "./TasksSideBarEdit.vue?vue&type=script&lang=js"
export * from "./TasksSideBarEdit.vue?vue&type=script&lang=js"
import style0 from "./TasksSideBarEdit.vue?vue&type=style&index=0&id=9e52a7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e52a7a0",
  null
  
)

export default component.exports